<div class="col-md-12">
    <div class="card-body">
        <div [ngClass]="{'flex-container': !showActions, 'flex-in-details': showActions}">
            <app-pressure-map *ngIf="analysis.type === 'Static'" [jsonData]="mappedToPressureMapStatic"
                [isStatic]="analysis.type === 'Static'" [showActions]="showActions" [width]="width"></app-pressure-map>
            <app-pressure-map *ngIf="analysis.type === 'Dynamic'" [jsonData]="mappedToPressureMapDynamicLeft"
                [isStatic]="false" [pointsToDraw]="feetAnalysis.left.pointsToDraw" [foot]="'LeftFoot'"
                [showActions]="showActions" [orderData]="orderData" [width]="width"
                [generatingPDF]="generatingPDF"></app-pressure-map>
            <app-pressure-map *ngIf="analysis.type === 'Dynamic'" [jsonData]="mappedToPressureMapDynamicRight"
                [isStatic]="false" [pointsToDraw]="feetAnalysis.right.pointsToDraw" [foot]="'RightFoot'"
                [showActions]="showActions" [orderData]="orderData" [width]="width"
                [generatingPDF]="generatingPDF"></app-pressure-map>
            <app-pressure-map *ngIf="analysis.type === 'Balance'" [jsonData]="mappedToPressureMapBalance"
                [isStatic]="false" [isBalance]="true" [showActions]="showActions" [width]="width"></app-pressure-map>
        </div>
    </div>
</div>